import { render, staticRenderFns } from "./LookerGrapherTab.vue?vue&type=template&id=83c51322&scoped=true"
import script from "./LookerGrapherTab.vue?vue&type=script&lang=js"
export * from "./LookerGrapherTab.vue?vue&type=script&lang=js"
import style0 from "./LookerGrapherTab.vue?vue&type=style&index=0&id=83c51322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c51322",
  null
  
)

export default component.exports